export default "__VITE_ASSET__CeSUCimH__"